import React from "react";

export const PlusIcon = () => {
    return (
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z" />
        </svg>
    );
};

export const ArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8px" height="12px" viewBox="0 0 8 12">
            <path d="M7.699,5.418 L2.243,0.300 C1.938,0.16 1.445,0.16 1.141,0.300 C0.837,0.586 0.837,1.49 1.141,1.334 L6.46,5.935 L1.141,10.536 C0.837,10.821 0.837,11.284 1.141,11.570 C1.293,11.712 1.493,11.784 1.692,11.784 C1.891,11.784 2.91,11.712 2.243,11.570 L7.699,6.453 C8.3,6.167 8.3,5.704 7.699,5.418 Z" />
        </svg>
    );
};

export const ArrowIconTwo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="15px" viewBox="0 0 14 15">
            <path d="M13.607,6.720 L7.575,0.770 C7.200,0.400 6.537,0.400 6.162,0.770 L0.386,6.468 C0.4,6.853 0.4,7.479 0.386,7.862 C0.777,8.247 1.408,8.247 1.800,7.862 L5.869,3.847 L5.869,13.441 C5.869,13.986 6.316,14.428 6.868,14.428 C7.421,14.428 7.867,13.986 7.867,13.441 L7.867,3.847 L12.194,8.116 C12.389,8.308 12.645,8.403 12.900,8.403 C13.156,8.403 13.412,8.308 13.607,8.116 C13.997,7.730 13.997,7.106 13.607,6.720 Z" />
        </svg>
    );
};

export const HalfArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23px" height="8px">
            <path d="M21.897,7.286 L0.974,7.286 C0.694,7.286 0.468,7.51 0.468,6.762 C0.468,6.471 0.694,6.237 0.974,6.237 L20.674,6.237 L15.944,1.333 C15.746,1.128 15.746,0.796 15.944,0.591 C16.142,0.386 16.462,0.386 16.660,0.591 L22.254,6.390 C22.399,6.541 22.443,6.767 22.365,6.963 C22.286,7.158 22.102,7.286 21.897,7.286 Z" />
        </svg>
    );
};

export const ArrowFillIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7px" height="5px">
            <path fillRule="evenodd" d="M3.499,4.999 L0.0,0.0 L6.999,0.0 L3.499,4.999 Z" />
        </svg>
    );
};

export const SlidePrevIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="57" viewBox="0 0 56 57" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.2374 43.7374C35.554 44.4209 34.446 44.4209 33.7626 43.7374L19.7626 29.7374C19.0791 29.054 19.0791 27.946 19.7626 27.2626L33.7626 13.2626C34.446 12.5791 35.554 12.5791 36.2374 13.2626C36.9209 13.946 36.9209 15.054 36.2374 15.7374L23.4749 28.5L36.2374 41.2626C36.9209 41.946 36.9209 43.054 36.2374 43.7374Z"
            />
        </svg>
    );
};

export const SlideNextIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="57" viewBox="0 0 56 57" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.7626 43.7374C20.446 44.4209 21.554 44.4209 22.2374 43.7374L36.2374 29.7374C36.9209 29.054 36.9209 27.946 36.2374 27.2626L22.2374 13.2626C21.554 12.5791 20.446 12.5791 19.7626 13.2626C19.0791 13.946 19.0791 15.054 19.7626 15.7374L32.5251 28.5L19.7626 41.2626C19.0791 41.946 19.0791 43.054 19.7626 43.7374Z"
            />
        </svg>
    );
};

export const ViewsEyeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23px" height="13px">
            <path d="M11.687,0.324 C6.17,0.324 0.708,4.424 0.708,6.287 C0.708,8.200 5.902,12.250 11.687,12.250 C17.471,12.250 22.666,8.200 22.666,6.287 C22.666,4.323 17.583,0.324 11.687,0.324 ZM16.28,6.287 C16.28,8.717 14.80,10.695 11.687,10.695 C9.294,10.695 7.346,8.717 7.346,6.287 C7.346,3.858 9.294,1.879 11.687,1.879 C14.80,1.879 16.28,3.858 16.28,6.287 ZM2.236,6.332 C2.374,5.748 4.185,4.23 6.862,2.897 C6.204,3.860 5.815,5.28 5.815,6.287 C5.815,7.568 6.218,8.751 6.896,9.724 C4.158,8.610 2.350,6.873 2.236,6.332 ZM16.474,9.729 C17.155,8.755 17.559,7.570 17.559,6.287 C17.559,5.2 17.153,3.813 16.470,2.840 C19.213,3.948 21.19,5.692 21.132,6.281 C20.990,6.890 19.194,8.624 16.474,9.729 Z" />
        </svg>
    );
};

export const NewArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2929 7.79289C11.6834 7.40237 12.3166 7.40237 12.7071 7.79289L20.7071 15.7929C21.0976 16.1834 21.0976 16.8166 20.7071 17.2071L12.7071 25.2071C12.3166 25.5976 11.6834 25.5976 11.2929 25.2071C10.9024 24.8166 10.9024 24.1834 11.2929 23.7929L18.5858 16.5L11.2929 9.20711C10.9024 8.81658 10.9024 8.18342 11.2929 7.79289Z"
            />
        </svg>
    );
};
